export default {
  name: "NavbarSection",
  computed: {
    in_pricing() {
      return this.$route.path === '/pricing' ? 'bg-dark-40' : '';
    }
  }
};
// bg-dark